import { fetchData, findMenuWithParent, getEncodedCookie, getEncryptedRoute, toasterrormsg } from '../../../reusable'
import { ToastContainer } from 'react-toastify'
import GoogleMapComponent from '../components/GoogleMapComponent'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { Link } from 'react-router-dom'
import { Tr } from '../../../_metronic/i18n/Tr'
import { FC, useEffect, useRef, useState } from 'react'
import { PageTitle } from '../../../_metronic/layout/core'
import Select from 'react-select'
import { useMenuContext } from '../contexts/MenuContext'

const ViewMaps: FC = () => {
  let t = Tr()

  const { fullMenu } = useMenuContext()
  const [selectedCategory, setSelectedCategory] = useState('') as any
  const [locationObj, setLocationObj] = useState(null) as any
  const [locations, setlocations] = useState([]) as any
  const [selectedPropertyId, setSelectedPropertyId] = useState('') as any
  const [image, setImage] = useState('') as any
  const [propertyName, setPropertyName] = useState('') as any
  const [propertyNumber, setPropertyNumber] = useState('') as any
  const [propertyEmail, setPropertyEmail] = useState('') as any
  const [totalProperty, setTotalProperty] = useState('') as any
  const [propertyType, setPropertyType] = useState('') as any
  const [propertyLocation, setPropertyLocation] = useState('') as any
  const [vendorId, setVendorId] = useState('') as any
  const [selectedFilter, setSelectedFilter] = useState([]) as any
  const [businessStatus, setBusinessStatus] = useState([]) as any
  const firstUpdate = useRef(true)

  const [categoryList] = useState([
    { value: '1', label: 'Accommodation' },
    { value: '3', label: 'Cafe Restaurant' },
    { value: '4', label: 'Space Rental' },
    { value: '5', label: 'Tour Package' },
    { value: '7', label: 'Car Rental' },
  ]) as any

  const [blank] = useState([])
  const [accommodationFilters] = useState([
    { value: 'topRated', label: 'Top Rated' },
    { value: 'mostReviewed', label: 'Most Reviewed' },
    { value: 'newestAccommodations', label: 'Newest Accommodations' },
  ])
  const [cafeRestaurantFilters] = useState([
    { value: 'topRated', label: 'Top Rated' },
    { value: 'mostReviewed', label: 'Most Reviewed' },
    { value: 'newestCafes', label: 'Newest Cafes' },
    { value: 'newestRestaurants', label: 'Newest Restaurant' },
  ])
  const [spaceRentalFilers] = useState([
    { value: 'topRated', label: 'Top Rated' },
    { value: 'mostReviewed', label: 'Most Reviewed' },
    { value: 'newestSpaceRental', label: 'Newest Space Rental' },
  ])
  const [tourPackageFilers] = useState([
    { value: 'topRated', label: 'Top Rated' },
    { value: 'mostReviewed', label: 'Most Reviewed' },
    { value: 'newestTourPackages', label: 'Newest Tour Packages' },
  ])
  const [carRentalFilers] = useState([
    { value: 'topRated', label: 'Top Rated' },
    { value: 'mostReviewed', label: 'Most Reviewed' },
    { value: 'newestCarRentals', label: 'Newest Car Rentals' },
  ])

  var logo = toAbsoluteUrl('/media/logos/uztripLogo.png')

  // This useEffect handles the category change and resets the filter.
  // We use a separate useEffect for this to ensure the filter state is updated before the API call is made.
  useEffect(() => {
    setSelectedFilter([])
  }, [selectedCategory]);


  // Use a single useEffect for the API call that depends on both category and filter
  useEffect(() => {
    // Only proceed if a category is selected and it's not the first render.
    // The ref ensures that the API call doesn't run on the component's initial mount.
    if (selectedCategory && !firstUpdate.current) {
      const timer = setTimeout(() => {
        propertyListApiCall();
      }, 500); // Debounce the API call by 500ms

      // Cleanup function to clear the previous timer
      return () => clearTimeout(timer);
    } else {
      firstUpdate.current = false;
    }
  }, [selectedCategory, selectedFilter]);

  const propertyListApiCall = async () => {
    const param: any = {
      categoryId: selectedCategory,
    }
    if (selectedFilter.length > 0) {
      selectedFilter.map((item: any) => {
        if (item.value == 'topRated') {
          param.topRated = true
        }

        if (item.value == 'mostReviewed') {
          param.mostReviewed = true
        }

        if (item.value == 'newestRestaurants') {
          param.newestProperties = true
          param.type = 'RESTAURANT'
        }

        if (item.value == 'newestCafes') {
          param.newestProperties = true
          param.type = 'CAFE'
        }

        if (
          item.value == 'newestCarRentals' ||
          item.value == 'newestTourPackages' ||
          item.value == 'newestSpaceRental' ||
          item.value == 'newestAccommodations'
        ) {
          param.newestProperties = true
        }
      })
    }

    const response: any = await fetchData('admin/propertieslocationlist', param)
    if (response.status == '200') {
      const data = response.data

      const validData = data.filter(
        (item: { latitude: any; longitude: any }) =>
          item.latitude != null &&
          item.latitude != undefined &&
          item.latitude != '' &&
          item.longitude != null &&
          item.longitude != undefined &&
          item.longitude != ''
      )

      const locations = validData.map(
        (item: { latitude: number; longitude: number; id: number }) => ({
          vendorId: item.id,
          lat: item.latitude,
          lng: item.longitude,
        })
      )

      if (locations.length == 0) {
        toasterrormsg('No Data Available')
        setImage("")
        setPropertyLocation("")
        setBusinessStatus("")
        setVendorId("")
        setPropertyName("")
        setPropertyEmail("")
        setPropertyNumber("")
        setTotalProperty("")
        setSelectedPropertyId("")
      }
      setlocations(locations)
    } else {
      toasterrormsg(response.message)
    }
  }

  const handleVendorIdChange = (propertyId: any) => {
    setSelectedPropertyId(propertyId) // Update the selected vendor ID
  }

  // this are the api for accommodation details
  const hotelDetailsApiCall = async () => {
    var param: any = {
      hotelId: selectedPropertyId,
    }
    var response: any = await fetchData('vendor/public/hotelDetailsV2', param)

    if (response.status == '200') {
      var data = response.data[0]
      setImage(data.images && data.images.length != 0 ? data.images[0].mediaPath : logo)
      setPropertyName(data.en_name != '' ? data.en_name : '')
      setBusinessStatus(data.businessInfostatus != '' ? data.businessInfostatus : '0')
      setVendorId(data.vendorId != '' ? data.vendorId : '')
      setPropertyLocation(data.location != '' ? data.location : '')
      setPropertyEmail(data.email != '' ? data.email : '')
      setPropertyNumber(data.mobileNumber != '' ? data.mobileNumber : '')
      setTotalProperty(data.noOfRooms != '' ? data.noOfRooms : '0')
      setPropertyType(
        data.propertyTypeDetail[0].en_name != '' ? data.propertyTypeDetail[0].en_name : ''
      )
    } else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    if (selectedPropertyId != '' && selectedPropertyId != undefined && selectedPropertyId != null) {
      if (selectedCategory == '1') {
        hotelDetailsApiCall()
      }
    }
  }, [selectedPropertyId])

  // this is the api call for cafe restaurant details

  const cafeRestaurantDetailApiCall = async () => {
    const param = {
      restaurantId: selectedPropertyId,
    }

    var response: any = await fetchData('vendor/public/restaurantDetail', param)

    if (response.status == '200') {
      var restaurantData = response.data[0]

      setImage(
        restaurantData.images && restaurantData.images.length != 0
          ? restaurantData.images[0].mediaPath
          : logo
      )
      setPropertyLocation(restaurantData.location != '' ? restaurantData.location : '')
      setBusinessStatus(
        restaurantData.businessInfostatus != '' ? restaurantData.businessInfostatus : '0'
      )
      setVendorId(restaurantData.vendorId != '' ? restaurantData.vendorId : '')
      setPropertyName(restaurantData.en_name != '' ? restaurantData.en_name : '')
      setPropertyEmail(restaurantData.email != '' ? restaurantData.email : '')
      setPropertyNumber(restaurantData.phoneNo != '' ? restaurantData.phoneNo : '')
      setPropertyType(restaurantData.type != '' ? restaurantData.type : '')
      setTotalProperty(
        restaurantData.restaurantmenu && restaurantData.restaurantmenu.length != 0
          ? restaurantData.restaurantmenu.length
          : '0'
      )
    } else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    if (selectedPropertyId != '' && selectedPropertyId != undefined && selectedPropertyId != null) {
      if (selectedCategory == '3') {
        cafeRestaurantDetailApiCall()
      }
    }
  }, [selectedPropertyId])

  // this is the api call for Space rental details

  const spaceRentalDetailApiCall = async () => {
    var param: any = {
      spacerentalId: String(selectedPropertyId),
    }
    var response: any = await fetchData('vendor/public/spaceDetails', param)

    if (response.status == '200') {
      var data = response.data[0]

      setImage(data.images && data.images.length != 0 ? data.images[0].mediaPath : logo)
      setPropertyLocation(data.location != '' ? data.location : '')
      setBusinessStatus(data.businessInfostatus != '' ? data.businessInfostatus : '0')
      setVendorId(data.vendorId != '' ? data.vendorId : '')
      setPropertyName(data.en_name != '' ? data.en_name : '')
      setPropertyEmail(data.email != '' ? data.email : '')
      setPropertyNumber(data.phoneNo != '' ? data.phoneNo : '')
      setTotalProperty(
        data.rentablespace && data.rentablespace.length != 0 ? data.rentablespace.length : '0'
      )
      setPropertyType(data.subcategory[0].en_name != '' ? data.subcategory[0].en_name : '')
    } else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    if (selectedPropertyId != '' && selectedPropertyId != undefined && selectedPropertyId != null) {
      if (selectedCategory == '4') {
        spaceRentalDetailApiCall()
      }
    }
  }, [selectedPropertyId])

  // this is the api call for Tour Package  details

  const tourPackageDetailApiCall = async () => {
    var param: any = {
      tourpackageId: String(selectedPropertyId),
    }
    var response: any = await fetchData('vendor/public/tourpackageDetails', param)

    if (response.status == '200') {
      var data = response.data[0]

      setImage(data.images && data.images.length != 0 ? data.images[0].mediaPath : logo)
      setPropertyLocation(data.location != '' ? data.location : '')
      setBusinessStatus(data.businessInfostatus != '' ? data.businessInfostatus : '0')
      setVendorId(data.vendorId != '' ? data.vendorId : '')
      setPropertyName(data.en_agencyName != '' ? data.en_agencyName : '')
      setPropertyEmail(data.email != '' ? data.email : '')
      setPropertyNumber(data.phoneNo != '' ? data.phoneNo : '')
      setTotalProperty(
        data.toursDetail && data.toursDetail.length != 0 ? data.toursDetail.length : '0'
      )
    } else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    if (selectedPropertyId != '' && selectedPropertyId != undefined && selectedPropertyId != null) {
      if (selectedCategory == '5') {
        tourPackageDetailApiCall()
      }
    }
  }, [selectedPropertyId])

  // this is the api call for Car Rental Details

  const carRentalDetailsApiCall = async () => {
    var param: any = {
      carrentalId: String(selectedPropertyId),
    }
    var response: any = await fetchData('vendor/public/carRentalDetail', param)

    if (response.status == '200') {
      var data = response.data[0]
      setImage(data.images && data.images.length != 0 ? data.images[0].mediaPath : logo)
      setPropertyLocation(data.location != '' ? data.location : '')
      setBusinessStatus(data.businessInfostatus != '' ? data.businessInfostatus : '0')
      setVendorId(data.vendorId != '' ? data.vendorId : '')
      setPropertyName(data.en_supplierName != '' ? data.en_supplierName : '')
      setPropertyEmail(data.email != '' ? data.email : '')
      setPropertyNumber(data.phoneNo != '' ? data.phoneNo : '')
      setTotalProperty(
        data.vehcileDetail && data.vehcileDetail.length != 0 ? data.vehcileDetail.length : '0'
      )
    } else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    if (selectedPropertyId != '' && selectedPropertyId != undefined && selectedPropertyId != null) {
      if (selectedCategory == '7') {
        carRentalDetailsApiCall()
      }
    }
  }, [selectedPropertyId])

  useEffect(() => {
    document.title = 'Insayr | View Maps'
  }, [])

  let result;
  const getBookingRoute = () => {
    if (selectedCategory == '1') {
      result = findMenuWithParent(fullMenu, '../viewhotels/');
      const menuId = result?.menu?.menuId
      return getEncryptedRoute('../hoteloverview', { menuId: menuId })
    }
    else if (selectedCategory == '3') {

      result = findMenuWithParent(fullMenu, '../viewrestaurants/');
      const menuId = result?.menu?.menuId
      return getEncryptedRoute('../restaurantoverview', { menuId: menuId })
    }
    else if (selectedCategory == '4') {

      result = findMenuWithParent(fullMenu, '../viewspacerentals/');
      const menuId = result?.menu?.menuId
      return getEncryptedRoute('../spacerentaloverview', { menuId: menuId })
    }
    else if (selectedCategory == '5') {

      result = findMenuWithParent(fullMenu, '../viewtourpackages/');
      const menuId = result?.menu?.menuId
      return getEncryptedRoute('../tourpackageoverview', { menuId: menuId })
    } else if (selectedCategory == '7') {
      
        result = findMenuWithParent(fullMenu, '../viewcarrentals/');
      const menuId = result?.menu?.menuId
      return getEncryptedRoute('../carrentaloverview', { menuId: menuId })
    }
    return '' // default fallback
  }

  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>{t('View Maps')}</PageTitle>
      <div className='d-flex flex-column flex-column-fluid'>
        <div id='kt_app_content' className='app-content flex-column-fluid'>
          <div className='form d-flex flex-column flex-lg-row'>
            <div className='d-flex flex-column flex-row-fluid gap-7 gap-lg-10'>
              <div className='tab-content'>
                <div
                  className='tab-pane fade show active'
                  id='kt_ecommerce_add_product_general'
                  role='tab-panel'
                >
                  <div className='d-flex flex-column'>
                    <div className='card card-flush py-4'>
                      <div className='card-body pt-10'>
                        <div className='row'>
                          <div className='col-lg-6 my-3'>
                            <label className='required fs-4 form-label'>{t("Category")}</label>
                            <Select
                              name='selectCategory'
                              id='selectCategory'
                              placeholder={t('Select Category')}
                              isSearchable={true}
                              options={categoryList}
                              value={
                                categoryList.find(
                                  (option: any) => option.value === selectedCategory
                                ) || null
                              }
                              onChange={(e: any) => {
                                setSelectedCategory(e.value)
                              }}
                            />
                          </div>
                          <div className='col-lg-6 my-3'>
                            <label className='required fs-4 form-label'>{t("Select Fiters")}</label>
                            <Select
                              name='selectFilter'
                              id='selectFilter'
                              placeholder={t('Select Filter')}
                              isSearchable={true}
                              isMulti={true}
                              value={selectedFilter}
                              options={
                                selectedCategory == 1
                                  ? accommodationFilters
                                  : selectedCategory == 3
                                    ? cafeRestaurantFilters
                                    : selectedCategory == 4
                                      ? spaceRentalFilers
                                      : selectedCategory == 5
                                        ? tourPackageFilers
                                        : selectedCategory == 7
                                          ? carRentalFilers
                                          : blank
                              }
                              onChange={(e: any) => {
                                setSelectedFilter(e)
                              }}
                            />
                          </div>
                          <GoogleMapComponent
                            latitude={''}
                            longitude={''}
                            onSelectLocation={(e: any) => setLocationObj(e)}
                            categoryId={selectedCategory}
                            multiLocations={locations}
                            onVendorIdChange={handleVendorIdChange}
                          />
                          {locations.length != 0 && selectedPropertyId != '' &&
                            selectedPropertyId != undefined &&
                            selectedPropertyId != null ? (
                            <div className='d-flex justify-content-center align-items-center'>
                              <div className='col-lg-10 mt-5'>
                                <div
                                  className='card map_detail_card mt-5'
                                  id='kt_profile_details_view'
                                >
                                  <div className='card-body p-9'>
                                    <div className='row mb-0 d-flex align-items-center'>
                                      <div className='col-lg-6'>
                                        <div className='d-flex justify-content-center align-items-center'>
                                          {' '}
                                          <img
                                            src={image}
                                            alt='Property Image'
                                            width={'100%'}
                                          />{' '}
                                        </div>
                                      </div>

                                      <div className='col-lg-6'>
                                        <Link
                                          to={getBookingRoute()}
                                          state={{
                                            hotelId: selectedPropertyId,
                                            restaurantId: selectedPropertyId,
                                            spacerentalId: selectedPropertyId,
                                            tourpackageId: selectedPropertyId,
                                            carrentalId: selectedPropertyId,
                                            vendorId: vendorId,
                                          }}
                                        >
                                          <div className='row mt-2'>
                                            <label className='col-lg-4 col-md-3 fw-bold text-muted'>
                                              {selectedCategory == '5'
                                                ? t('Agency Name')
                                                : selectedCategory == '7'
                                                  ? t('Supplier Name')
                                                  : t('Property Name')}
                                            </label>
                                            <div className='col-lg-8  col-md-8 '>
                                              <span className='fw-bolder fs-6 text-primary text-decoration-underline '>
                                                {' '}
                                                {propertyName}
                                              </span>
                                            </div>
                                          </div>
                                        </Link>

                                        <div className='row mt-2 '>
                                          <label className='col-lg-4 col-md-3 fw-bold text-muted'>
                                            {t("Email")}
                                          </label>
                                          <div className='col-lg-8 col-md-8'>
                                            <span className='fw-bolder fs-6 text-dark'>
                                              {' '}
                                              {propertyEmail}
                                            </span>
                                          </div>
                                        </div>
                                        <div className='row mt-2'>
                                          <label className='col-lg-4 col-md-3 fw-bold text-muted'>
                                            {t("Mobile Number")}
                                          </label>
                                          <div className='col-lg-8 col-md-8'>
                                            <span className='fw-bolder fs-6 text-dark'>
                                              {' '}
                                              {propertyNumber}
                                            </span>
                                          </div>
                                        </div>
                                        <div className='row mt-2'>
                                          <label className='col-lg-4 col-md-3 fw-bold text-muted'>
                                            {selectedCategory == 3
                                              ? t('Total Menu Items')
                                              : selectedCategory == '4'
                                                ? t('Total Rentable Space')
                                                : selectedCategory == '5'
                                                  ? t('Total Tours')
                                                  : selectedCategory == '7'
                                                    ? t('Total Remtable Cars')
                                                    : t('Total Room')}
                                          </label>
                                          <div className='col-lg-8 col-md-8'>
                                            <span className='fw-bolder fs-6 text-dark'>
                                              {' '}
                                              {totalProperty}
                                            </span>
                                          </div>
                                        </div>

                                        {selectedCategory != 5 && selectedCategory != 7 ? (
                                          <div className='row mt-2'>
                                            <label className='col-lg-4 col-md-3 fw-bold text-muted'>
                                              {t("Property Type")}
                                            </label>
                                            <div className='col-lg-8 col-md-8'>
                                              <span className='fw-bolder fs-6 text-dark'>
                                                {' '}
                                                {propertyType}
                                              </span>
                                            </div>
                                          </div>
                                        ) : (
                                          ''
                                        )}
                                        <div className='row mt-2'>
                                          <label className='col-lg-4 col-md-3 fw-bold text-muted'>
                                            {t("Location")}
                                          </label>
                                          <div className='col-lg-8 col-md-8'>
                                            <span className='fw-bolder fs-6 text-dark'>
                                              {' '}
                                              {propertyLocation}
                                            </span>
                                          </div>
                                        </div>
                                        <div className='row mt-2'>
                                          <label className='col-lg-4 col-md-3 fw-bold text-muted'>
                                            {t("Business Status")}
                                          </label>
                                          <div className='col-lg-8 col-md-8'>
                                            <span className='fw-bolder fs-6 text-dark'>
                                              {businessStatus == 0 ? (
                                                <span className='badge badge-warning mx-2'>
                                                  {t("Pending")}
                                                </span>
                                              ) : businessStatus == 1 ? (
                                                <span className='badge badge-success mx-2'>
                                                  {t("Approved")}
                                                </span>
                                              ) : businessStatus == 2 ? (
                                                <span className='badge badge-light-danger mx-2'>
                                                  {t("Rejected")}
                                                </span>
                                              ) : (
                                                ''
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export { ViewMaps }
